import { date, datetime, format, getValueFromJson } from "../../../utils/index";
import I18n from "../../../I18n";
import { Buffer } from "buffer";

const processIdObject = (options, json) => {
    const cdmKeysToUse = getValueFromJson(options, "id");
    const idsToProxy = Object.entries(cdmKeysToUse || {}).reduce((acc, [cdmKey, cmdValue]) => {
        acc[`${cmdValue}`] = (json[cdmKey] || {}).value;
        return acc;
    }, {});

    return {
        id: Buffer.from(JSON.stringify(idsToProxy)).toString("base64"),
        name: (json[getValueFromJson(options, "name")] || {}).value,
        __typename: getValueFromJson(options, "__typename"),
    };
};

const processIdString = (options, json) => {
    const keyValue = (json[getValueFromJson(options, "id")] || {}).value;
    // TODO: Discuss approach to be able to navigate from hyperlinks and maintain the view integrity
    /**
     *  INSERT INTO `field_definition` (`ID`, `CDMName`, `Metadata`, `DefaultValue`, `ViewOrder`, `CampistaOrder`, `CollapseFieldName`, `HideField`, `SortableField`, `FilterProps`, `ExportableFieldOrder`, `TotalizedField`)
        VALUES
            ('217', 'CDM_SalesInvoices.TransactionID', '{\"type\": \"object\", \"label\": \"Transaction ID\", \"options\": {\"id\": \"CDM_SalesInvoices.TransactionID\", \"name\": \"CDM_SalesInvoices.TransactionID\", \"__typename\": \"Transaction\", \"drillDownNavigationKey\": \"TransactionID\"}}', NULL, '7', '3.40', NULL, '0', '1', '{\"name\": \"Transaction\", \"type\": \"Like\", \"table\": \"CDM_SalesInvoices\"}', '14', '0');

     */
    // const drillDownNavigationKey = getValueFromJson(options, "drillDownNavigationKey") ? getValueFromJson(options, "drillDownNavigationKey") : "FKID"
    const drillDownNavigationKey = "FKID"
    const cdmKeyToConnection = getValueFromJson(options, "cdmKey")
        ? `${getValueFromJson(options, "cdmKey")}.${drillDownNavigationKey}`
        : `CDM_${getValueFromJson(options, "__typename")}s.${drillDownNavigationKey}`;
    const idToProxy = {
        [`${cdmKeyToConnection}`]: keyValue,
    };
    return {
        id: Buffer.from(JSON.stringify(idToProxy)).toString("base64"),
        name: (json[getValueFromJson(options, "name")] || {}).value,
        __typename: getValueFromJson(options, "__typename"),
    };
};

const getFormattedValue = (value, defaultValue) => {
    return value !== undefined ? value : defaultValue;
};

export const formatValueByType = (json, value, type, options, defaultValue, mask) => {
    let formatedValue = "";
    switch (type) {
        case "date":
            formatedValue = date(value, mask, false) || "N/A";
            break;
        case "currency":
            formatedValue = format(
                value,
                "normal",
                getValueFromJson(options, "currency"),
                getValueFromJson(options, "fractionDigits"),
                getValueFromJson(options, "locale"),
            );
            break;
        case "number":
            formatedValue = format(
                value,
                "normal",
                null,
                getValueFromJson(options, "fractionDigits"),
            );
            break;
        case "percentage":
            formatedValue =
                value === null || value === undefined
                    ? null
                    : format(value, "normal", null, getValueFromJson(options, "fractionDigits"));
            break;
        case "datetime":
            formatedValue = datetime(value, mask, false) || "N/A";
            break;
        case "object": {
            const valueFromConfig = getValueFromJson(options, "id");
            const hasValue = (json[getValueFromJson(options, "id")] || {}).value;

            let objToReturn = null;

            switch (typeof valueFromConfig) {
                case "object":
                    objToReturn = processIdObject(options, json);
                    break;
                case "string":
                    objToReturn = processIdString(options, json);
                    break;
                default:
                    objToReturn = getFormattedValue(
                        (json[getValueFromJson(options, "name")] || {}).value,
                        defaultValue,
                    );
                    break;
            }

            objToReturn = hasValue
                ? objToReturn
                : (json[getValueFromJson(options, "name")] || {}).value || defaultValue;

            return {
                type: hasValue ? type : "string",
                value: objToReturn || "N/A",
            };
        }
        case "boolean":
            formatedValue = !!value === true ? I18n.translate(`Yes`) : I18n.translate(`No`);
            break;
        default:
            formatedValue = value || (defaultValue ? defaultValue : "N/A");
            break;
    }

    return { type, value: formatedValue };
};
